import { useManagementResource } from './managementModel';
export function ChannelOwnerLink({ request, id, admin, onOpen }) {
  const state = useManagementResource(
    request,
    admin && id ? `/conversations/${id}/owner` : null,
  );
  return state.data?.owner ? (
    <button
      type="button"
      className="inbox-header-button"
      onClick={() => onOpen(state.data.owner)}
    >
      Manage {state.data.owner.kind === 'CUSTOMER' ? 'customer' : 'worker'}
    </button>
  ) : state.error ? (
    <button type="button" onClick={state.reload}>
      Retry owner settings
    </button>
  ) : null;
}
